// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Space,
  Table,
  TableColumnProps
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';

const FormItem = Form.Item;

interface UmsResourceCategory {
  id?: number;
  name: string;
  sort?: number;
  createTime?: string;
}

function ResourceCategoryManagement() {
  const [form] = Form.useForm<UmsResourceCategory>();
  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState<UmsResourceCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const formRef = useRef<any>({});

  // 获取数据列表
  const getList = () => {
    setLoading(true);

    get('/resourceCategory/listAll')
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          setDataList(data || []);
        } else {
          Message.error(message || '获取数据失败!');
        }
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '编号',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '名称',
      dataIndex: 'name',
      width: 200
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      width: 180,
      render: (text) => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      title: '排序',
      dataIndex: 'sort',
      width: 100,
      render: (text) => text || 0
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 150,
      render: (_, record: UmsResourceCategory) => (
        <Space>
          <Button 
            type="text" 
            onClick={() => edit(record)} 
            loading={loading}
          >
            编辑
          </Button>
          <Popconfirm 
            focusLock 
            title="提示" 
            content="是否要删除该分类?" 
            onOk={() => del(record)}
          >
            <Button 
              type="text" 
              status="danger" 
              loading={loading}
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  // 新增分类
  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({
      sort: 0
    });
    setVisible(true);
  };

  // 删除分类
  const del = (record: UmsResourceCategory) => {
    if (!record.id) {
      Message.error('分类ID不存在！');
      return;
    }
    setLoading(true);

    post(`/resourceCategory/delete/${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑分类
  const edit = (record: UmsResourceCategory) => {
    formRef.current = record;
    form.setFieldsValue(record);
    setVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      setLoading(true);
      const data = {
        ...formRef.current,
        ...values
      };

      if (formRef.current.id) {
        // 更新分类
        post(`/resourceCategory/update/${formRef.current.id}`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('编辑成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // 创建分类
        post(`/resourceCategory/create`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('新增成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className="resource-category-management table-flex">
      <div className="filter-section">
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline">
          <Button type="primary" onClick={add} loading={loading}>
            添加
          </Button>
        </Form>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={dataList}
        className="table-scroll"
        scroll={{ y: '100%', x: '100%' }}
        loading={loading}
      />

      {/* 新增/编辑分类弹框 */}
      <Modal
        title={formRef.current.id ? '编辑分类' : '添加分类'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 500 }}
        confirmLoading={loading}
      >
        <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <FormItem 
            label="名称:" 
            field="name" 
            rules={[{ required: true, message: '请输入名称' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="排序:" field="sort">
            <Input type="number" placeholder="0" />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default ResourceCategoryManagement;

